export const getADAPersonComponent = (document: Document): Element | null =>
  (document && document.getElementById('ada-entry')) || null

export const isADAChatAvailable = (document: Document) =>
  getADAPersonComponent(document) ? true : false
